<template>
  <div
    class="gw_input_wrapper"
    :class="{ gw_input_error: touched && getErrors().length }"
  >
    <slot name="label">
      <!-- // TODO add v-if and check styles where it will fade as this label some margin -->
      <div class="gw_input_label">
        {{ label }}
      </div>
    </slot>
    <textarea
      v-if="isTextArea"
      ref="textarea"
      class="gw_input pt-2"
      style="--input-height: 10rem"
      :style="{ resize: noResize && 'none' }"
      spellcheck="false"
      :placeholder="placeholder"
      :tabindex="tabindex"
      :autofocus="autofocus"
      :value="value"
      :data-tst="`${tstPrefix}gw_textarea`"
      @input="
        e => {
          touched = true
          $emit('input', e, e.target.value)
        }
      "
      @keydown.stop.enter.exact.prevent="$emit('keydown:enter')"
      @keydown.stop.enter.shift.exact.prevent="e => $emit('input', e, `${value}\n`)"
    />
    <input
      v-else
      ref="input"
      class="gw_input"
      spellcheck="false"
      type="text"
      :placeholder="placeholder"
      :tabindex="tabindex"
      :autofocus="autofocus"
      :value="value"
      :data-tst="`${tstPrefix}gw_input`"
      @input="
        e => {
          touched = true
          $emit('input', e, e.target.value)
        }
      "
      @keydown.stop.enter.exact.prevent="$emit('keydown:enter')"
    />
    <div
      v-for="error in touched ? getErrors() : []"
      :key="error"
      class="clr-error text-small mt-1"
    >
      {{ error }}
    </div>
  </div>
</template>

<script>
import { nextTick } from 'vue'

export default {
  name: 'GwInput',
  props: {
    tstPrefix: {
      type: String,
      default: '',
    },
    isTextArea: {
      type: Boolean,
      default: false,
    },
    noResize: {
      type: Boolean,
    },
    tabindex: {
      type: Number,
      default: 1,
    },
    label: {
      type: String,
      default: '',
    },
    getErrors: {
      type: Function,
      default: () => () => inputValue => [],
    },
    placeholder: {
      type: String,
      default: '',
    },
    value: {
      type: [String, Number],
      default: '',
    },
    autofocus: Boolean,
    spellcheck: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['input', 'keydown:enter'],
  data() {
    return {
      touched: false,
    }
  },
  mounted() {
    if (!this.autofocus) return
    nextTick(() => {
      this.focus()
    })
  },
  methods: {
    focus() {
      if (this.$refs.input) {
        this.$refs.input.focus()
      }
      if (this.$refs.textarea) {
        this.$refs.textarea.focus()
      }
    },
  },
}
</script>
